export default {
	bind(el, binding) {
		let loading = false;
		el.addEventListener('click',(e)=>{
			if(loading) return;
			loading = true;
			el.classList.add('loading');
			binding.value(e)
			.finally(() => {
				loading = false;
				el.classList.remove('loading');
			});
		});
	},
};